export default __webpack_public_path__ + "static/media/gravel_banner.2940b2d9.jpg";